import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./global.css";
import "./App.css";
import { ToastContainer,Slide } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";
import Login from "./components/Login/Login"
import ChatWindow from "./components/ChatWindow/ChatWindow";
import ConversationView from "./components/ChatWindow/ConversationView";
import Logout from "./components/Login/Logout";
import SettingsPage from "./components/Settings/SettingsPage";
import ProtectedRoute from "./components/Login/ProtectedRoute";
import AppBootstrap from "./components/AppBootstrap";
import SupportScreen from "./components/ChatWindow/support/SupportScreen";
import useInactivityHeartbeat from './hooks/useInactivityHeartbeat';
import DataDumpPage from "./components/ChatWindow/DataDumpPage";
import DashboardAgentPage from "./components/DashboardAgent/DashboardAgentPage";
import {
  PlatformAuditPage,
  PlatformBillingPage,
  PlatformCustomersPage,
  PlatformDashboardPage,
  PlatformOnboardingPage,
  PlatformSettingsPage,
} from "./components/SuperAdmin/SuperAdminConsolePages";
import PlatformWorkspacePage from "./components/SuperAdmin/PlatformWorkspacePage";
import OnPremOverviewPage from "./components/OnPremAdmin/OnPremOverviewPage";
import OnPremOnboardingPage from "./components/OnPremAdmin/OnPremOnboardingPage";
import OnPremLogsPage from "./components/OnPremAdmin/OnPremLogsPage";
//import UserManagement from "./components/Settings/UserManagement";


const App = () => {
  useInactivityHeartbeat(); // Initialize the inactivity heartbeat hook
    return (
         <Router>
          <div className="App bg-background text-foreground">
         <Routes>

          <Route path="/" element={<Login />} />

          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

         <Route path="/" element={<ProtectedRoute><AppBootstrap /></ProtectedRoute>}>
          <Route path="chatwindow" element={<ChatWindow />} />
          <Route path="dashboard" element={<DashboardAgentPage />} />
          <Route path= "support" element={<SupportScreen />} />
          <Route path="conversations" element={<ConversationView />} />
          <Route path="datadump" element={<DataDumpPage />} />
          <Route path="platform" element={<PlatformWorkspacePage managed={PlatformDashboardPage} onPrem={OnPremOverviewPage} />} />
          <Route path="platform/customers" element={<PlatformCustomersPage />} />
          <Route path="platform/onboarding" element={<PlatformWorkspacePage managed={PlatformOnboardingPage} onPrem={OnPremOnboardingPage} />} />
          <Route path="platform/logs" element={<PlatformWorkspacePage onPrem={OnPremLogsPage} />} />
          <Route path="platform/billing" element={<PlatformBillingPage />} />
          <Route path="platform/audit" element={<PlatformAuditPage />} />
          <Route path="platform/settings" element={<PlatformSettingsPage />} />
          {/*<Route path="users" element={<UserManagement />} />*/}

          <Route path="settings" element={<SettingsPage />}>
          </Route>
        </Route>
        </Routes>
      </div>
     <ToastContainer
     position="top-right"
     autoClose={2000}
     hideProgressBar={true}
     newestOnTop={false}
     closeOnClick
     pauseOnFocusLoss={false}
     draggable={false}
     pauseOnHover={true}
     closeButton={false}
     transition={Slide}
     zIndex={2000}
     toastClassName=""
     bodyClassName=""
     progressClassName=""
    />

    </Router>
  );
};

export default App;
